/* eslint-disable camelcase */
import React from 'react';
import { appraiseLogo } from '../images';
import axios from 'axios';
import { BASE_URL } from '../Config';
import Toast from '@applane/react-toast';
import { useState } from 'react';


export default () => {

  const { pathname } = typeof window !== undefined ? window.location : { pathname: '/' };
  const pathSegments = pathname.split('/');
  const token = pathSegments[pathSegments.length - 1];
  const [actionData, setActionData] = useState('subscribed')
  console.log('tokenhandleUnsub', actionData)

  const handleUnsub = async () => {
    const props = {
      id: 'addRecordInNotificationsUnsubsCustomer', 
      paramValue: { data: {token, action:'unsub'} },
    }

    return await axios.post(`${BASE_URL}/invoke`, props)
      .then((res) =>{
        const response = res.data.response
        setActionData(response.action)
        if (response) {
          Toast.show({
            message: response.action === 'already-unsubscribed' ? 'Warning' : 'Success',
            description: response.message,
            type: response.action === 'already-unsubscribed' ? 'warning' : 'success',
            position: 'top',
            direction: 'left',
            duration: 5000,

          });
        }
      }  
    )
  } 

  const handleSub = async () => {
    const props = {
      id: 'addRecordInNotificationsUnsubsCustomer', 
      paramValue: { data: {token, action:'sub'} },
    }

    return await axios.post(`${BASE_URL}/invoke`, props)
      .then((res) =>{
        const response = res.data.response
        setActionData(response.action)
        if (response) {
          Toast.show({
            message: response.action === 'already-unsubscribed' ? 'Warning' : 'Success',
            description: response.message,
            type: response.action === 'already-unsubscribed' ? 'warning' : 'success',
            position: 'top',
            direction: 'left',
            duration: 5000,

          });
        }
      }  
    )
  } 
  
  return (
    <main
      style={{
        alignItems: "center",
        backgroundColor: "#F7FAFC",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        minHeight: "100vh",
        paddingTop: "15rem",
        paddingBottom: "3rem",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          width: "100%",
          textAlign: "center",
          
        }}
      >
        <div>
            <div style={{

                marginBottom:"6rem"
                }}>
            <img
                alt="Company Logo"
                src={appraiseLogo}       
                style={{height:"8rem",
                width:"15rem"}}
            />
          </div>
          <h2
            style={{
              color: "#1A202C",
              fontSize: "3rem",
              fontWeight: "800",
              marginTop: "3rem",
              textAlign: "center",
            }}
          >
            We're sorry to see you go!
          </h2>
          <p
            style={{
              color: "#718096",
              fontSize: "2rem",
              marginTop: "1.5rem",
              textAlign: "center",
            }}
          >
            You are receiving email / sms of vehicles offer. If you wish to unsubscribe, please
            click the button below.
          </p>
        </div>
        <div
          style={{
            marginTop: "2rem",
          }}
        >
          <div
            style={{
              borderRadius: "0.375rem",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
              width: "150px",
              margin:'auto'
            }}
          >
          {actionData === 'unsubscribed' || actionData === 'already-unsubscribed' ? (
            <button
              style={{
                backgroundColor: "#4C51BF",
                border: "none",
                borderRadius: "0.375rem",
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                color: "#fff",
                cursor: "pointer",
                display: "flex",
                fontSize: "1.5rem",
                fontWeight: "500",
                justifyContent: "center",
                padding: "0.5rem 1rem",
                width: "100%",
                marginTop: "4rem"
              }}
              onClick={handleSub}
            >
              Subscribe again!
            </button>
          ) : (
            <button
              style={{
                backgroundColor: "#4C51BF",
                border: "none",
                borderRadius: "0.375rem",
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                color: "#fff",
                cursor: "pointer",
                display: "flex",
                fontSize: "1.5rem",
                fontWeight: "500",
                justifyContent: "center",
                padding: "0.5rem 1rem",
                width: "100%",
                marginTop: "4rem"
              }}
              onClick={handleUnsub}
            >
              Unsubscribe
            </button>
          )}

          </div>
        </div>
        <footer
          style={{
            color: "#718096",
            fontSize: "1.3rem",
            marginTop: "2rem",
            textAlign: "center",
          }}
        >
          <p>Thank you for your past support. If you have any questions, please contact us at appraisals@appraiseall.net</p>
        </footer>
      </div>
    </main>
  )
};
